import { useGetLead } from '../../../../graphql/queries';

import { useSplitClient } from './useSplitClient';

export function useUserIdSplitClient() {
  const userId = useGetLead().data?.lead?.corePostgresUserId;
  const stringUserId = userId ? String(userId) : undefined;

  return useSplitClient(stringUserId);
}
